import { useFormikContext } from 'formik';
import React, { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { Name } from '../../../models/Name';
import { getCredentialsTypeWithPagination } from '../../../services/credentialsService';
import { getErrorMessage } from '../../../services/utilities/ServiceError';
import { getStatusName } from '../../../utilities/CredentialUtil';
import CredentialDateInfo from '../credential-date-info';

interface Props {
    taskDescription: string;
    taskProcedure: string;
    onBack: (event: any) => void;
    isEdit: boolean,
}

const SummaryForm: FC<Props> = ({ taskDescription, taskProcedure, onBack, isEdit }) => {
    const { values } = useFormikContext<any>();
    const [credentialTypes, setcredentialTypes] = useState<Name[]>([]);
    const { translate } = useLocale();

    useEffect(() => {
        buildCrentialTypes();
    }, [])

    const buildCrentialTypes = async () => {
        try {
            const type = await getCredentialsTypeWithPagination();
            setcredentialTypes(type.rows);
        } catch (error) {
            toast.warn(getErrorMessage(error));
        }
    }

    const getType = (typeId: number) => {
        let type: string = '';

        try { // prevent crash when a card type can't be determined. E.g. after MDE/Omnikey read.
            credentialTypes.forEach(item => {
                if (item.value === typeId.toString()) {
                    type = item.label;
                }
            })
        } catch (err) {
            const prefix = `Failed to get enrolled card type: `; // For context on where the error occurred.
            console.error(prefix + getErrorMessage(err));
        }

        return type;
    }

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        {!isEdit ?
            <div className="flex flex-row">
                <div className="flex flex-col flex-1">
                    <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.taskDetails)}:</h2>
                    <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.task)}: <span className="text-sm text-black">{taskDescription}</span></h4>
                    <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.procedure)}: <span className="text-sm text-black">{taskProcedure}</span></h4>
                </div>
            </div> : null
        }
        <div className="flex flex-row pt-3">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.enrolmentDetails)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.tagCode)}: <span className="text-sm text-black">{values.tagDisplay}</span></h4>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.type)}: <span className="text-sm text-black">{getType(values.typeId)}</span></h4>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.status)}: <span className="text-sm text-black">{getStatusName(values.statusId, translate)}</span></h4>
                {
                    values.tagByteReversed === 1 ?
                        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.mifareBytesReversed)}: <span className="text-sm text-black">{translate.byKey(TranslationKeys.yes)}</span></h4>
                        : null
                }
                <CredentialDateInfo values={values}/>
            </div>
        </div>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5 "
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    data-cy="confirmButton"
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type="submit">{translate.byKey(TranslationKeys.confirm)}</button>
            </div>
        </div>
    </div>
}

export default SummaryForm;
